var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { memo, useState } from "react";
// components
import Edelicon from "@frameworks/shared-library/components/Generic/Edelicon";
import MFPlaceOrderClientNameColumn from "@frameworks/salesjourney/components/Features/PlaceOrder/MutualFund/MFPlaceOrderClientNameColumn";
import RadioButton from "@frameworks/web/components/generic/radioButton";
import { EClientAcntType } from "@frameworks/web/components/features/LoginFlow/constant";
import { nanoid } from "nanoid";
//Img
import ClientSearch from "@frameworks/shared-library/assets/images/SalesJourney/clientSearch.svg";
import noResultsFound from "@frameworks/shared-library/assets/images/markets/noResultsFound.svg";
import { RadioBtnHoldingdata } from "./RadioBtnHoldingdata";
import { EInvestmentType } from "@frameworks/shared-library/components/TransactionJourney/MutualFund/MutualFundConstant";
var ClientSchemeselectionBody = function (_a) {
    var clientDetails = _a.clientDetails, selectedHolding = _a.selectedHolding, setclientDetails = _a.setclientDetails, setSelectedHolding = _a.setSelectedHolding, transactionType = _a.transactionType, mfHoldingData = _a.mfHoldingData, callBackOnClientSearchSelection = _a.callBackOnClientSearchSelection, setEnableContinue = _a.setEnableContinue;
    var _b = __read(useState(false), 2), clientSearchPopup = _b[0], setClientSearchPopup = _b[1];
    var targetTrxId = nanoid();
    var handleClientSearchSelection = function (data) {
        callBackOnClientSearchSelection(data);
        setClientSearchPopup(false);
    };
    var handleOnChangeRadioButton = function (e) {
        e.stopPropagation();
        var selectedIsin = e.target.value;
        var selectedHolding = mfHoldingData.find(function (x) { return x.isin === selectedIsin; }) || null;
        setSelectedHolding(selectedHolding);
    };
    var getMsgHeader = function () {
        if (clientDetails) {
            if ((mfHoldingData === null || mfHoldingData === void 0 ? void 0 : mfHoldingData.length) > 0)
                return "Select Scheme type for ".concat(getOrderType());
            else if (clientDetails.accType === EClientAcntType.REG ||
                clientDetails.accType === EClientAcntType.OTC)
                return "The selected client is not allowed to place an order in Mutual Fund";
            else
                return transactionType === EInvestmentType.STP
                    ? "No Physical Holdings Found"
                    : "No Holdings Found";
        }
        else {
            return "Search Client for ".concat(getOrderType());
        }
    };
    var getSubText = function () {
        if (clientDetails) {
            if ((mfHoldingData === null || mfHoldingData === void 0 ? void 0 : mfHoldingData.length) > 0)
                return "";
            else if (clientDetails.accType === EClientAcntType.REG ||
                clientDetails.accType === EClientAcntType.OTC)
                return "";
            else
                return "Client does not have holdings in this scheme";
        }
        else {
            return "Search by name, PAN, or UCC to find the client and proceed.";
        }
    };
    var getOrderType = function () {
        switch (transactionType) {
            case EInvestmentType.SIP:
            case EInvestmentType.LUMPSUM:
                return "Investment";
            case EInvestmentType.REDEEM:
                return "Redemption";
            case EInvestmentType.SWP:
                return "Systematic Withdrawal";
            case EInvestmentType.STP:
                return "Systematic Transfer";
            case EInvestmentType.SWITCH:
                return "Switch fund";
            default:
                return "placing an order"; // generic wording incase any new transaction type is seen
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "client-scheme-selection-body" },
            React.createElement("div", { className: "client-selection-section" },
                !clientDetails && (React.createElement("span", { className: "lh-140 DMSanN_14_400 txt_blackOne1" }, "Client Name")),
                React.createElement(MFPlaceOrderClientNameColumn, { clientDetails: clientDetails, transactionId: targetTrxId, setTransactionId: function () { }, targetTransactionId: targetTrxId, searchClientPopup: clientSearchPopup, showNameAsLink: true, setSearchClientPopup: setClientSearchPopup, callbackHandleClientSearchSelection: handleClientSearchSelection, customeIcon: React.createElement(Edelicon, { className: "edel-icon-editicon-underline txt-han-blue DMSans_20_300 ", paths: 3, onClick: function () {
                            setclientDetails(null);
                            setEnableContinue && setEnableContinue(false);
                        } }), hideClientSearchRightContent: true, searchInputPlaceholder: "Search by Client\u2019s name/ PAN/ UCC", showSearchCount: true })),
            clientDetails && (mfHoldingData === null || mfHoldingData === void 0 ? void 0 : mfHoldingData.length) > 0 && (React.createElement("div", { className: "holding-selection-container" },
                React.createElement("label", { className: "DMSanN_14_400 txt_blackOne1 " }, "Scheme type"),
                React.createElement("div", { className: "holding-list-container" }, mfHoldingData.map(function (item, index) {
                    return (React.createElement("div", { className: "radio-item-container ".concat((mfHoldingData === null || mfHoldingData === void 0 ? void 0 : mfHoldingData.length) > 1 &&
                            index !== 0 &&
                            "separation-border"), key: "".concat(index, "-").concat(item === null || item === void 0 ? void 0 : item.isin) },
                        React.createElement(RadioButton, { className: "common-radio-button holding-radio", name: "holding", list: { display: "", value: item === null || item === void 0 ? void 0 : item.isin }, onChange: handleOnChangeRadioButton, selected: selectedHolding === null || selectedHolding === void 0 ? void 0 : selectedHolding.isin, key: 0, disabled: false }),
                        React.createElement(RadioBtnHoldingdata, { schemeName: item === null || item === void 0 ? void 0 : item.isinName, amount: item === null || item === void 0 ? void 0 : item.marketValue, units: item === null || item === void 0 ? void 0 : item.totalQty })));
                })))),
            React.createElement("div", { className: "flex-container" },
                React.createElement("div", { className: "flexCenter msg-container text-center" },
                    React.createElement("div", { className: "pb-20" },
                        React.createElement("img", { src: clientDetails && (mfHoldingData === null || mfHoldingData === void 0 ? void 0 : mfHoldingData.length) < 1
                                ? noResultsFound
                                : ClientSearch })),
                    React.createElement("span", { className: "DMSansMedium_20_500 txt_purple-gray" }, getMsgHeader()),
                    React.createElement("span", { className: "lh-140 DMSans_13_400 txt-whispering-periwinkle" }, getSubText()))))));
};
export default memo(ClientSchemeselectionBody);
